import {
  SAVE_REPORT_DRAFT,
  SAVE_REPORT_DRAFT_SUCCESS,
  SAVE_REPORT_DRAFT_FAILURE,
  FETCH_REPORT_DRAFT,
  FETCH_REPORT_DRAFT_SUCCESS,
  FETCH_REPORT_DRAFT_FAILURE,
  FETCH_REPORT_DRAFT_VERSIONS,
  FETCH_REPORT_DRAFT_VERSIONS_SUCCESS,
  FETCH_REPORT_DRAFT_VERSIONS_FAILURE,
  CLEAR_REPORT_DRAFT,
  CLEAR_SAVE_DRAFT_STATUS
} from './types';

// Save Draft Actions
export const saveReportDraft = (payload) => ({
  type: SAVE_REPORT_DRAFT,
  payload
});

export const saveReportDraftSuccess = (payload) => ({
  type: SAVE_REPORT_DRAFT_SUCCESS,
  payload
});

export const saveReportDraftFailure = (error) => ({
  type: SAVE_REPORT_DRAFT_FAILURE,
  error
});

// Fetch Draft Actions
export const fetchReportDraft = (payload) => ({
  type: FETCH_REPORT_DRAFT,
  payload
});

export const fetchReportDraftSuccess = (payload) => ({
  type: FETCH_REPORT_DRAFT_SUCCESS,
  payload
});

export const fetchReportDraftFailure = (error) => ({
  type: FETCH_REPORT_DRAFT_FAILURE,
  error
});

// Fetch Draft Versions Actions
export const fetchReportDraftVersions = (payload) => ({
  type: FETCH_REPORT_DRAFT_VERSIONS,
  payload
});

export const fetchReportDraftVersionsSuccess = (payload) => ({
  type: FETCH_REPORT_DRAFT_VERSIONS_SUCCESS,
  payload
});

export const fetchReportDraftVersionsFailure = (error) => ({
  type: FETCH_REPORT_DRAFT_VERSIONS_FAILURE,
  error
});

// Clear Actions
export const clearReportDraft = () => ({
  type: CLEAR_REPORT_DRAFT
});

export const clearSaveDraftStatus = () => ({
  type: CLEAR_SAVE_DRAFT_STATUS
});

